import { AuthGuard, PermissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetComponent } from './components/asset.component';
import { AssetDetailsComponent } from './components/asset-details/asset-details.component';

const routes: Routes = [
  {
    path: '',
    component: AssetComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: ':id',
    component: AssetDetailsComponent,
    canActivate: [AuthGuard, PermissionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssetRoutingModule {}
